import { Tabs } from "antd";
import { useState, useEffect } from "react";
import axios from "axios";

import Constituent from "./contentSettingCode/Constituent";
import DifficultWordType from "./contentSettingCode/DifficultWordType";
import ErrorType from "./contentSettingCode/ErrorType";
import SentencePattern from "./contentSettingCode/SentencePattern";
import Tense from "./contentSettingCode/Tense";
import PartsOfSpeech from "./contentSettingCode/PartsOfSpeech";

const backend = process.env.REACT_APP_BACKEND

function ContentSettingCode () {

    // useEffect(()=>{
    //     axios.get(`${backend}/contents/code`)
    //     .then(data=>{
    //         console.log(data)
    //     })
    //     .catch(err=>{
    //         console.log(err)
    //     })
    // })

    const items = [
        { label: "형식", key: "item-1", style:{height:"100%"}, children: <SentencePattern /> }, // remember to pass the key prop
        { label: "시제", key: "item-2", style:{height:"100%"}, children: <Tense /> },
        { label: "성분", key: "item-3", style:{height:"100%"}, children: <Constituent /> },
        { label: "오류유형", key: "item-4", style:{height:"100%"}, children: <ErrorType /> },
        { label: "어려운 단어 유형", key: "item-5", style:{height:"100%"}, children: <DifficultWordType /> },
        { label: "품사", key: "item-6", style:{height:"100%"}, children: <PartsOfSpeech /> },
      ];
    
      return (
        <div style={{width:"100%", height:"100%"}}>
          <Tabs defaultActiveKey="item-1" destroyInactiveTabPane={true} type="card" size="middle" items={items} style={{height:"100%", width:"100%"}}/>
        </div>
      );
}

export default ContentSettingCode